"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userSpecificChange = exports._configUserSpecificSelector = exports.trafficSourceSelector = exports.userSpecificIsLoadedSelector = exports.userSpecificSelector = exports.reducer = exports.setModulePath = void 0;
var get = require("lodash/get");
var getTrafficSource_1 = __importDefault(require("./getTrafficSource"));
var edgeConfigModule_1 = require("./edgeConfigModule");
var userSpecificTypes_1 = require("./userSpecificTypes");
var mapUserSpecificUserId_1 = require("./__internal/mapUserSpecificUserId");
__exportStar(require("./userSpecificTypes"), exports);
var defaultState = {
    isLoaded: false,
    userSpecific: {},
    configUserSpecific: null,
};
var modulePath = '';
function setModulePath(path) {
    modulePath = path;
}
exports.setModulePath = setModulePath;
function reducer(state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case userSpecificTypes_1.UserSpecificActions.userSpecificChange: {
            var trafficSource = state.trafficSource;
            try {
                trafficSource = (0, getTrafficSource_1.default)(action.payload);
            }
            catch (e) {
                console.error(e);
            }
            return __assign(__assign({}, state), { isLoaded: true, userSpecific: __assign(__assign({}, state.userSpecific), action.payload), trafficSource: trafficSource });
        }
        case userSpecificTypes_1.UserSpecificActions.resetStores: {
            return __assign(__assign({}, state), { isLoaded: false, userSpecific: {} });
        }
        case edgeConfigModule_1.Actions.configChange: {
            // if user specific is null, we should not change current user specific
            // as it's tells us that config didn't have it
            // so we shouldn't change it, but leave it unchanged
            // In case of log-out there would be user specific, but with empty token field
            var hasUserSpecific = action.payload && action.payload.globals && action.payload.globals.userSpecificData;
            var userSpecific = hasUserSpecific
                ? (0, mapUserSpecificUserId_1.mapUserSpecificUserId)(action.payload.globals.userSpecificData)
                : state.configUserSpecific;
            return __assign(__assign({}, state), { configUserSpecific: userSpecific });
        }
        default: {
            return state;
        }
    }
}
exports.reducer = reducer;
var getLocalState = function (state) { return get(state, modulePath, defaultState); };
var userSpecificSelector = function (state) { return getLocalState(state).userSpecific; };
exports.userSpecificSelector = userSpecificSelector;
var userSpecificIsLoadedSelector = function (state) { return getLocalState(state).isLoaded; };
exports.userSpecificIsLoadedSelector = userSpecificIsLoadedSelector;
var trafficSourceSelector = function (state) { return getLocalState(state).trafficSource; };
exports.trafficSourceSelector = trafficSourceSelector;
var _configUserSpecificSelector = function (state) {
    return getLocalState(state).configUserSpecific;
};
exports._configUserSpecificSelector = _configUserSpecificSelector;
var userSpecificChange = function (userSpecific) { return ({
    type: userSpecificTypes_1.UserSpecificActions.userSpecificChange,
    payload: userSpecific,
}); };
exports.userSpecificChange = userSpecificChange;
